import { render, staticRenderFns } from "./hazardPagination2.vue?vue&type=template&id=038d558f&"
import script from "./hazardPagination2.vue?vue&type=script&lang=js&"
export * from "./hazardPagination2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports